document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu-item-has-children');
    const main = document.querySelector('main');

    menuItems.forEach(item => {
        const link = item.querySelector('a');
        const submenu = item.querySelector('.sub-menu');

        if (!link || !submenu) return;

        link.addEventListener('click', function (e) {
            e.preventDefault();

            const isOpen = item.classList.contains('open');

            // Stäng alla andra öppna menyer
            menuItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('open');
                    const otherSubmenu = otherItem.querySelector('.sub-menu');
                    const otherLink = otherItem.querySelector('a');

                    if (otherSubmenu) otherSubmenu.style.display = 'none';

                    if (otherLink && otherItem.closest('#menu-mobilmeny')) {
                        otherLink.textContent = 'Visa mer';
                    }
                }
            });

            item.classList.toggle('open');
            submenu.style.display = isOpen ? 'none' : 'flex';

            if (item.closest('#menu-mobilmeny')) {
                link.textContent = isOpen ? 'Visa mer' : 'Visa mindre';
            }
        });
    });

    // Klick på <main> => stäng alla öppna menyer
    if (main) {
        main.addEventListener('click', function () {
            menuItems.forEach(item => {
                item.classList.remove('open');
                const submenu = item.querySelector('.sub-menu');
                const link = item.querySelector('a');

                if (submenu) submenu.style.display = 'none';

                if (link && item.closest('#menu-mobilmeny')) {
                    link.textContent = 'Visa mer';
                }
            });
        });
    }
});
//# sourceMappingURL=mobile-navigation.js.map
